import React from 'react';
import { ScrollProgressBar } from '../components/ScrollProgressBar';
import { StickyTopBar } from '../components/StickyTopBar';
import { HeroSection } from '../components/HeroSection';
import { PainAgitationSection } from '../components/PainAgitationSection';
import { CreatorSection } from '../components/CreatorSection';
import { ScienceSection } from '../components/ScienceSection';
import { TimelineSection } from '../components/TimelineSection';
import { PriceAnchoringSection } from '../components/PriceAnchoringSection';
import { FeaturedTestimonial } from '../components/FeaturedTestimonial';
import { TestimonialCarousel } from '../components/TestimonialCarousel';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { FooterSection } from '../components/FooterSection';
export function LuckyFlushPage() {
  return <div className="min-h-screen bg-navy font-sans text-cream selection:bg-gold/30 selection:text-cream" data-id="element-320">
      <ScrollProgressBar data-id="element-321" />
      <StickyTopBar data-id="element-322" />

      <main className="flex flex-col w-full" data-id="element-323">
        <HeroSection data-id="element-324" />
        <PainAgitationSection data-id="element-325" />
        <CreatorSection data-id="element-326" />
        <ScienceSection data-id="element-327" />
        <TimelineSection data-id="element-328" />
        <PriceAnchoringSection data-id="element-329" />
        <FeaturedTestimonial data-id="element-330" />
        <TestimonialCarousel data-id="element-331" />
        <GuaranteeSection data-id="element-332" />
        <FAQSection data-id="element-333" />
        <FinalCTASection data-id="element-334" />
      </main>

      <FooterSection data-id="element-335" />
    </div>;
}